import React from "react";

export default function About() {
  return (
    <main>
      <section
        className="relative grain min-h-[60vh] flex items-center"
        style={{
          background:
            "linear-gradient(180deg, #f3efea 0%, #fdfbf7 100%)",
        }}
      >
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10 py-24">
          <div className="overline">The house of</div>
          <h1 className="font-serif text-6xl sm:text-7xl lg:text-[110px] leading-[1] mt-4 max-w-3xl">
            konokangen<span className="text-[#c58b76]">.</span>
          </h1>
          <p className="text-lg text-[#5c5a56] mt-10 max-w-xl leading-relaxed">
            Konoka in Sanskrit means a corner — a small, intimate space. Konokangen is the
            corner-garden: a quiet place where craftspeople, designers and women writing
            their own stories meet over objects worth keeping.
          </p>
        </div>
      </section>

      <section className="max-w-[1200px] mx-auto px-6 lg:px-10 py-24 grid lg:grid-cols-2 gap-16 items-start">
        <div className="aspect-[4/5] overflow-hidden">
          <img
            src="https://static.prod-images.emergentagent.com/jobs/ee5196d8-7ba8-419d-a53c-e1c97e62948a/images/05e89f087a5bc7875f0d4948f92463e94669028b4741c01da05bdefb61d462ee.png"
            alt="Bracelet"
            className="w-full h-full object-cover"
          />
        </div>
        <div>
          <div className="overline">Our craft</div>
          <h2 className="font-serif text-4xl mt-3 leading-tight">Five generations, one bench.</h2>
          <p className="text-[#5c5a56] mt-6 leading-relaxed">
            Every Konokangen piece begins in Jaipur, where our karigars have shaped
            temple-grade gold for over a century. We pair their hands with contemporary
            design, recycled metals and lab-grown stones — for jewellery that respects
            both heritage and the earth.
          </p>
          <div className="mt-10 grid grid-cols-2 gap-8">
            {[
              ["100%", "Recycled gold sourcing"],
              ["BIS", "Hallmark certified"],
              ["3-5d", "Made-to-order"],
              ["1yr", "Free re-polishing"],
            ].map(([k, v]) => (
              <div key={k} className="border-t border-[#ebe5df] pt-4">
                <div className="font-serif text-4xl">{k}</div>
                <div className="text-xs tracking-[0.16em] uppercase text-[#5c5a56] mt-2">{v}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
